export const TEXT_ARE_FIELDS = [
    "B. Partnership's name, address, city, state, and ZIP code",
    "F. Name, address, city, state, and ZIP code for partner entered in E.",
    "Part 1: B. Entity's name, address, city, state and zip code",
    "Part 2: D. Partner's / Shareholder's name, address, city, state and zip code",
    "Partnership's Name, Address and ZIP Code",
    "Partner's Name, Address and ZIP Code",
    "A. 1. Share of Partnership Income (Loss) - Individuals Filing Form D-400 Enter Amount on",
    "B. 7. Portion of Line 2 Above Attributable to N.C. Source Income - Individuals Filing Form D-400 Enter Amount on",
    "B. 8. Portion of Line 3 Above Attributable to N.C. Source Income - Individuals Filing Form D-400 Enter Amount on",
    "C. 10. Share of North Carolina Taxable Income, if the amount is less than zero - Individuals Filing Form D-400 Enter Amount on",
    "C. 11. Share of North Carolina Taxable Income, if the amount is greater than zero - Individuals Filing Form D-400 Enter Amount on",
    "Part I - Investor's / owner's / beneficiary's name and address",
    "Part I - Entity name and address",
    "ENTITY INFORMATION - Name, address, city, state and ZIP code:",
    "TAXPAYER INFORMATION - Name, address, city, state and ZIP code:",
    "Partnership's name, address, and ZIP",
    "Partner's name, address, and ZIP",
    "D. Partner's name, address, city, state, and ZIP code",
    "Other Information",
    "16. Utah other deductions (describe)",
    "12. Utah other income/loss (describe",
    "Owner Information - Name",
    "Pass-Through Entity (PTE) Information - Name",
    "PART I - B. Partnership's name, address, city, state, and zip code",
    "Part I: Partnership - B. Name, Address, City, State, and Zip Code",
    "Part II: Partner - D. Name, Address, City, State, and Zip Code",
    "Partnership's Name, Address and ZIP Code",
    "Partner's Name, Address and ZIP Code",
    "1-4. - (d) Form N-11 & N-15 filers enter the amount in column (b) and /or column (c) on:",
    "6-7. - (d) Form N-11 & N-15 filers enter the amount in column (b) and /or column (c) on:",
    "12-14. - (d) Form N-11 & N-15 filers enter the amount in column (b) and /or column (c) on:",
    "16-20. - (d) Form N-11 & N-15 filers enter the amount in column (b) and /or column (c) on:",
    "Partnership's name, address, and Postal/ZIP Code",
    "Partner's name, address, and Postal/ZIP Code",
    "31b. - (d) Form N-11 & N-15 filers enter the amount in column (b) and /or column (c) on:",
    "32a-32b. - (d) Form N-11 & N-15 filers enter the amount in column (b) and /or column (c) on:",
    "37. - (d) Form N-11 & N-15 filers enter the amount in column (b) and /or column (c) on:",
    "Owner's name, address, and ZIP code",
    "Pass-through entity's name, address, and ZIP code",
    "Partnership's Name, Address, and Zip Code",
    "Partner's Name, Address, and Zip Code",
    "Partnership's name, address, and Zip code",
    "Partner's name, address, and Zip code",
    "12. Utah other income/loss (describe)",
    "ADDITIONAL INFORMATION"
]

export const FOOTNOTES_TO_SHOW = [
    "11", "13", "14", "15", "17", "20"
]

export const LEGEND_DATA = [
    { color: 'lightgreen', label: 'Valid field' },
    { color: 'lightpink', label: 'Invalid field' },
    { color: 'lightblue', label: 'Field has a footnote' }
];